import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth, startGoogleLogin } from "@/lib/auth";
import { LogOut, User as UserIcon } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const onLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl"
      style={{ background: "rgba(248,246,240,0.78)", borderBottom: "1px solid var(--line)" }}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <span className="font-serif-display text-2xl tracking-tight" style={{ color: "var(--forest)" }}>
            Humming<span style={{ color: "var(--terracotta)" }}>Stayz</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm">
          {[
            ["/", "Home"],
            ["/listings", "Stays"],
            ["/dashboard", "Host"],
          ].map(([to, label]) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={`nav-${label.toLowerCase()}`}
              className={({ isActive }) =>
                `transition-colors duration-200 ${isActive ? "text-[color:var(--forest)] font-medium" : "text-[color:var(--text-2)] hover:text-[color:var(--forest)]"}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link
                to="/bookings"
                className="hidden sm:inline-flex text-sm text-[color:var(--text-2)] hover:text-[color:var(--forest)]"
                data-testid="nav-my-bookings"
                style={{ display: "none" }}
              >
                My Bookings
              </Link>
              <div className="flex items-center gap-2 px-3 py-2 rounded-full" style={{ background: "var(--surface-alt)" }} data-testid="user-chip">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-7 h-7 rounded-full object-cover" />
                ) : (
                  <UserIcon className="w-5 h-5" />
                )}
                <span className="text-sm hidden sm:inline" data-testid="user-name">{user.name}</span>
              </div>
              <button onClick={onLogout} className="btn-pill btn-outline-dark" data-testid="logout-btn">
                <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Logout</span>
              </button>
            </>
          ) : (
            <button onClick={startGoogleLogin} className="btn-pill btn-primary" data-testid="login-btn">
              Sign in
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
